<template>
  <div class="modal fade confirm" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">編輯個人資訊<span class="modal-title text-red ml-3">(我已確實取得客戶同意，為客戶進行資料建檔！)</span></h3>
        </div>
        <div class="modal-body">
          <form class="form">
            <div class="form-group row">
              <label for="birth-year" class="col-3 text-right">Email</label>
              <div class="col-9">
                <input type="email" class="form-control form-control-inline" v-model="form.email" maxlength="50" @input="checkInputEmail" />
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">傳真</label>
              <div class="col-9">
                <input
                  type="tel"
                  maxlength="5"
                  @input="numberFax0"
                  class="form-control form-control-inline form-short"
                  v-model="form.fax[0]"
                />
                <span class="text">-</span>
                <input
                  type="tel"
                  maxlength="20"
                  @input="numberFax1"
                  class="form-control form-control-inline"
                  v-model="form.fax[1]"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">職業分類</label>
              <div class="col-9">
                <b
                  v-if="form.career_box"
                  class="text px-3 text-green"
                >第{{ form.careerCategory }}類  {{ form.career_name }}</b>
                <b
                  v-else
                  class="text px-3 text-green"
                >{{ form.career }}</b>
                <!--<a class="btn btn-red m-0" v-if="form.career || form.career_box" @click="deleteCareer">刪除</a>-->
                <a class="btn btn-default m-0"  @click="jobPickingOpen=true">請選擇</a>
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">介紹人</label>
              <div class="col-9">
                <!-- <input type="text" 
                v-show="form.introducerId === ''"
                class="form-control form-control-inline" v-model="form.introducer">-->
                <b
                  v-show="form.introducerId !== ''"
                  class="text px-3 text-green"
                >{{ form.introducer }}</b>
                <a class="btn btn-red m-0" v-if="form.introducerId !== ''" @click="deleteIntr">刪除</a>
                <a v-else class="btn btn-default m-0" @click="clientSearchOpen = true">從既有客戶查詢</a>
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">服務單位</label>
              <div class="col-9">
                <input type="text" class="form-control form-control-inline" v-model="form.agency" maxlength="30" @input="checkInputAgency" @blur="checkInputAgency" />
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">學歷</label>
              <div class="col-9">
                <select class="form-control form-control-inline form-wide" v-model="form.education">
                  <option value>請選擇</option>
                  <option
                    v-for="(e, eid) in eduOpt"
                    :key="`city-item-${eid}`"
                    :value="e.val"
                  >{{e.text}}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="gender-1" class="col-3 text-right">婚姻</label>
              <div class="col-9">
                <select class="form-control form-control-inline" v-model="form.marriage">
                  <option value>請選擇</option>
                  <option
                    v-for="(m, mid) in marriageOpt"
                    :key="`city-item-${mid}`"
                    :value="m.val"
                  >{{m.text}}</option>
                </select>
              </div>
            </div>

            <div class="action text-right">
              <a @click="$emit('close')" class="btn btn-default">取消</a>
              <a @click.stop.prevent="submit()" class="btn btn-primary">儲存</a>
            </div>
          </form>
        </div>
      </div>
    </div>
    <search-client-modal
      :open="clientSearchOpen"
      @submit="submitClient"
      @close="clientSearchOpen = false"
    />
    <job-picking-modal :open="jobPickingOpen" @submit="submitJob" @close="jobPickingOpen=false" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchClientModal from "./SearchClientModal";
import { commonMixin } from "@/mixins/common";
import JobPickingModal from "./JobPickingModal";

export default {
  name: "SocailDataModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    inputs: {
      type: Object,
      default: null
    },
    custInfo: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters([ 'UserInfo' ]),    
    isBox() {
     //判斷是否為box
     return this.UserInfo.userType === 'box'
    }
  },
  watch: {
    open: "transformToEnum"
  },
  components: { SearchClientModal, JobPickingModal },
  data() {
    return {
      jobPickingOpen: false,
      eduOpt: [
        { text: "國中及以下", val: "1" },
        { text: "高中/職", val: "2" },
        { text: "專科", val: "3" },
        { text: "大學", val: "4" },
        { text: "研究所以上", val: "5" }
      ],
      marriageOpt: [
        { text: "未婚", val: "1" },
        { text: "已婚", val: "2" },
        { text: "離婚", val: "3" },
        { text: "其他", val: "4" }
      ],
      clientSearchOpen: false,
      form: {
        fax: ["", ""],
        email: "",
        career: "",
        career_name:"",
        career_box:"",
        careerCategory: "",
        introducer: "",
        introducerId: "",
        agency: "",
        education: "",
        marriage: "",
        serNo: ""
      }
      // form: {
      //   lineid: !this.inputs ? 0 : this.inputs.lineid,
      //   email: !this.inputs ? 0 : this.inputs.email,
      //   career: !this.inputs ? 0 : this.inputs.career,
      //   introducer: !this.inputs ? 0 : this.inputs.introducer,
      //   agency: !this.inputs ? 0 : this.inputs.agency,
      //   education: !this.inputs ? 0 : this.inputs.education,
      //   marriage: !this.inputs ? 0 : this.inputs.marriage
      // }
    };
  },
  methods: {
    //檢查Email
    checkInputEmail(){
      this.form.email = this.form.email.replace(/[<>!#$^&,"'?%*:;()+{}[\]|~`=\\]/g,'');
    },    
    //檢查服務單位
    checkInputAgency(){
      this.form.agency = this.form.agency.replace(/[<>!@#$^&,"'?%*:;+{}[\]|~`=\\]/g,'');
      if (this.stringBytes(this.form.agency, false, 30) > 30) {
        this.form.agency = this.form.agency.substring(0, this.stringBytes(this.form.agency, true, 30));
      }
    },
    numberFax0() {
      this.form.fax[0] = this.form.fax[0].replace(/[^\d]/g, "");
    },
    numberFax1() {
      this.form.fax[1] = this.form.fax[1].replace(/[^\d]/g, "");
    },
    submitClient(member) {
      this.form.introducer = member.name;
      this.form.introducerId = member.id;
      this.clientSearchOpen = false;
    },
    submitJob(job) {
      this.form.career_name = job.job_name;
      this.form.careerCategory = job.job_cat;
      this.form.career_box = job.job_code
      this.jobPickingOpen = false;
    },
    checkWordLimit() {
      // 檢查欄位字數
      if (
        this.form.email.length > 50 ||
        this.form.fax[0].length > 5 ||
        this.form.fax[1].length > 20 ||
        this.form.agency.length > 30
      ) {
        return true;
      } else {
        return false;
      }
    },
    deleteIntr() {
      this.form.introducer = "";
      this.form.introducerId = "";
    },
    deleteCareer() {
      this.form.careerCategory = "";
      this.form.career = "";
    },
    submit() {
      if (this.checkWordLimit()) {
        // 檢查欄位字數
        return this.$toast.info({ title: "欄位字數超過限制" });
      }
      let emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (emailPattern.test(this.form.email) || this.form.email === "") {
        if (this.$store.state.custInfo.ID === "") {
          this.form.serNo = this.$store.state.custInfo.serNo;
        }
        this.$emit("submit", this.form);

      } else {
        this.$toast.info({ title: "Email 格式不對請重新輸入" });
      }
    },
    transformToEnum(val) {
      if (val && this.inputs) {
        this.form.email = this.inputs.email;
        this.form.career = this.inputs.career;
        this.form.career_box = this.inputs.career_box;
        this.form.careerCategory = this.inputs.job_cat;
        this.form.career_name = this.inputs.job_name;
        this.form.introducer = this.inputs.introducer;
        this.form.introducerId = this.inputs.introducerId;
        this.form.agency = this.inputs.agency;
        let uncheckEdu = this.eduOpt.filter(
          item => item.text == this.inputs.education
        );
        this.form.education = uncheckEdu.length ? uncheckEdu[0].val : "";
        let uncheckMarriage = this.marriageOpt.filter(
          item => item.text == this.inputs.marriage
        );
        this.form.marriage = uncheckMarriage.length
          ? uncheckMarriage[0].val
          : "";
        this.form.fax = this.inputs.fax;
      }
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    }
  },
  mounted() {}
};
</script>
